import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        count: 0,
        menuFixed: true,
        menuFixedOld: true,
        menuHover: false,
        menuClicked: false,
        openMenuMobile:false,
        isLoadingPage: true,
        blackoutShow: false,
        disabledButtonSubmit: false,
        groupUser:[],
        currentPage: {
            pageId: 0,
            moduleId: 0,
            menuPageId: 0,
            name: "",
            path: "",
            pageTitle: "",
            singularTitle: "",
            viewDefaultReportId: 0,
        },
        currentPageSettings: {
            menuButtons: {
                right: false
            }
        },
        lastPage:{
            name: "",
            path: "",
            query: {},
        },
        languages: [
            {
                type: "en",
                name: "English"
            },
            {
                type: "es",
                name: "Español"
            },
            {
                type: "pt-BR",
                name: "Português"
            }
        ],
        account: {
            domain: "",
            name: "",
            login: "",
            authorization: "",
            token: "",
            tempPassword: false,
            module: "",
            custom: false,
        },
        template: {
            colorPrimary: "",
            colorSecondary: "",
            colorLight: "",
            logoSmall: "",
            logoMedium: "",
            logoLarge: "",
            logoWhite: "",
            font: ""
        }
    },
    mutations: {
        testeMutation(state) {
            state.count++
        },
        setAccount(state, account) {
            state.account = account
        },
        setToggleMenuFixed(state) {
            state.menuFixed = !state.menuFixed;
            state.menuFixedOld = state.menuFixed;

        },
        setMenuFixed(state, fixed) {
            state.menuFixed = fixed;
        },
        setOpenMenuMobile(state, open) {
            state.openMenuMobile = open;
        },
        setGroupUser(state, groupUser){
            state.groupUser = groupUser
        },
        setIsLoadingPage(state, isLoadingPage) {
            state.isLoadingPage = isLoadingPage;
        },
        setMenuFixedOld(state, fixed) {
            state.menuFixedOld = fixed;
        },
        setMenuHover(state, fixed) {
            state.menuHover = fixed;
        },
        setItemMenuClicked(state) {
            state.menuClicked = true;
            setTimeout(() => {
                state.menuClicked = false;
            }, 500)
        },
        setCurrentPage(state, currentPage) {
            state.currentPage = currentPage
        },
        setPageMenuButtonsRight(state, right) {
            state.currentPageSettings.menuButtons.right = right
        },
        setDisabledButtonSubmit(state, disabled) {
            state.disabledButtonSubmit = disabled
        },
        setPageBlackoutShow(state, blackoutShow) {
            state.blackoutShow = blackoutShow
        },
        setLastPage(state, lastPage) {
            state.lastPage = lastPage
        },
    },
    actions: {
        teste({commit}) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    commit('testeMutation')
                    resolve()
                }, 2000)
            })
        }

    },
    getters: {
        getLanguages(state) {
            return state.languages
        },
        getCurrentPageSettings(state) {
            return state.currentPageSettings
        },
        getGroupUser(state){
          return state.groupUser
        },
        getCurrentPage(state) {
            return state.currentPage
        },
        getPageMenuButtonsRight(state) {
            return state.currentPageSettings.menuButtons.right
        },
        getMenuFixed(state) {
            return state.menuFixed
        },
        getMenuFixedOld(state) {
            return state.menuFixedOld
        },
        getMenuHover(state) {
            return state.menuHover
        },
        getMenuClicked(state) {
            return state.menuClicked
        },
        getOpenMenuMobile(state) {
            return state.openMenuMobile
        },
        getIsLoadingPage(state) {
            return state.isLoadingPage
        },
        getItemMenuActiveId(state) {
            return state.currentPage.menuPageId
        },
        getPageBlackoutShow(state) {
            return state.blackoutShow
        },
        getDisabledButtonSubmit(state) {
            return state.disabledButtonSubmit
        },
        getAccountUser(state) {
            //localStorage.getItem('account')
            return state.account
        },
        getLastPage(state) {
            return state.lastPage
        },
    }
})
